import { UseConvertZonedDateTime } from "./UseConvertZonedDateTime";

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

const getDaySuffix = (day) => {
    if (day >= 11 && day <= 13) {
        return 'th';
    }
    switch (day % 10) {
        case 1:
            return 'st';
        case 2:
            return 'nd';
        case 3:
            return 'rd';
        default:
            return 'th';
    }
};

// passedDate is a naive 'YYYY-MM-DD HH:MM:SS' wall-clock string stored in fromTimeZone (defaults to the
// viewer's own timezone, i.e. no conversion, for values that aren't tied to a specific creation timezone)
const UseParseDateMonthYearTime = (passedDate, fromTimeZone) => {
    if (!passedDate) {
        return "";
    }

    const browserTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const localDateTime = UseConvertZonedDateTime(passedDate, fromTimeZone || browserTimeZone, browserTimeZone);

    const [datePart, timePart = '00:00:00'] = String(localDateTime).trim().replace('T', ' ').split(' ');
    const [year, month, day] = datePart.split('-').map(Number);
    const [hours, minutes] = timePart.split(':').map(Number);

    const suffix = getDaySuffix(day);

    return `${day}${suffix} ${MONTHS[month - 1]}, ${year} ${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
};

export default UseParseDateMonthYearTime;
